import { ProgressBar } from "primereact/progressbar";
import { Skeleton } from "primereact/skeleton";
import C from "classnames";
import S from "./UserSnapshot.module.scss";

export const UserSnapshot = ({
  userSnapshot,
  leaderboard,
  isLoading = false,
  showLeaderboard = true,
}) => {
  if (isLoading) {
    return (
      <div className={S.userSnapshot}>
        <div className={S.section}>
          <Skeleton width="80px" height="1.5rem" className="mb-2" />
          <Skeleton width="100%" height="101px" />
        </div>
        <div className={S.section}>
          <Skeleton width="150px" height="1.5rem" className="mb-2" />
          <Skeleton width="100%" height="101px" />
        </div>
        <div className={S.section}>
          <Skeleton width="120px" height="1.5rem" className="mb-2" />
          <Skeleton width="100%" height="101px" />
        </div>
      </div>
    );
  }

  if (Object.keys(userSnapshot).length === 0 && !leaderboard?.length) {
    return null;
  }

  const { currentLevel, lessons } = userSnapshot;

  return (
    <div className={S.userSnapshot}>
      {currentLevel && (
        <div className={S.section}>
          <h3 className="atlas-h5 mb-2">Level</h3>
          <div className={S.content}>
            <p className="body-md">{currentLevel.levelName}</p>
            <ProgressBar
              value={currentLevel.statsProgress}
              showValue={false}
              className={S.levelProgress}
            />
            <p>
              {currentLevel.statsCurrent}
              <span className={S.mutedText}>
                {" / "}
                {currentLevel.statsTotal} lessons to next level
              </span>
            </p>
          </div>
        </div>
      )}

      {lessons && (
        <div className={S.section}>
          <h3 className="atlas-h5 mb-2">Lessons Completed</h3>
          <div className={S.content}>
            <div className={C(S.lessonsCompleted, "atlas-h1")}>
              {lessons.completed} <span className={S.mutedText}> / {lessons.total} </span>
            </div>
            {lessons.recentlyCompleted > 0 && (
              <div className={S.mutedText}>+{lessons.recentlyCompleted} recently completed</div>
            )}
          </div>
        </div>
      )}

      {showLeaderboard && leaderboard?.length > 0 && (
        <div className={S.section}>
          <h3 className="atlas-h5">Leaderboard</h3>
          <div className={S.content}>
            <div className={S.leaderboard}>
              {leaderboard.map(entry => (
                <div
                  key={entry.userId}
                  className={C(S.leaderboardEntry, { [S.isSelf]: entry.isSelf })}
                >
                  <div className={S.leaderboardPosition}>{entry.position}</div>
                  <div className={S.leaderboardName}>{entry.fullName}</div>
                  <div className={C(S.leaderboardPoints, "uppercase")}>{entry.points} points</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
